<script setup lang="ts">
import useLetterAvg from "~/composables/useLetterAvg";

// URLのページ番号取得
const route = useRoute();

// ページの初期値は0で初期化 あればURLのそれを使う
const current = computed(() => {
  return route.query.off ? parseInt(route.query.off.toString()) : 0;
});
// データー取得処理
const { data, pending } = await useFetch(
  () => `/api/review/list?off=${current.value}`,
);

// レビューの平均評価
const avg = await useLetterAvg();

// メタ設定
useHead({
  title: "外構・リフォーム工事をされたお客様の声・評判・口コミ",
  meta: [
    {
      name: "description",
      content: `実際にファミリー庭園で外構工事をされたお客様からのレビューや感想のお手紙。${avg.value.total}件公開中。`,
    },
  ],
});

useBreadcrumbs([
  { name: "TOP", path: "/" },
  { name: "お客様の声", path: "/e_list" },
]);

useScrollTop(true);
</script>

<template>
  <div class="p-review wrapper mb-16">
    <TextPageTitle>お客様の声</TextPageTitle>
    <div v-if="current == 0 && avg" class="border-gray-400 mb-12">
      <TextSectionTitle class="mb-4"
        >ファミリー庭園 お客様の評価</TextSectionTitle
      >
      <div class="flex justify-around">
        <div>
          <p class="text-sm">総合満足度平均</p>
          <p>
            <span class="text-orange-600 font-bold text-4xl">{{
              avg.avg.enq_5
            }}</span
            >%
          </p>
          <p class="text-sm">{{ avg.total }}件のお手紙</p>
        </div>

        <div class="flex flex-col justify-center whitespace-nowrap min-w-[30%]">
          <div class="flex items-center mb-4">
            <p class="text-sm mr-2">対応満足度</p>
            <ReviewScoreBar :score="avg.avg.enq_1" />
          </div>
          <div class="flex items-center">
            <p class="text-sm mr-2">価格満足度</p>
            <ReviewScoreBar :score="avg.avg.enq_2" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-end justify-between py-2">
      <p class="flex items-baseline text-sm">
        <span class="text-2xl bold">{{ avg?.total }}</span>
        件
      </p>
      <PaginationCompact
        v-if="avg"
        :params="{
          count: avg.total,
          current: current,
          perPage: 30,
          max: 100,
        }"
      />
    </div>
    <div class="min-h-screen relative mb-16">
      <transition name="fade">
        <ListResponsiveWrapper v-if="!pending">
          <ReviewItemCard
            v-for="(d, idx) in data"
            :key="d.kouji_cd"
            :data="d"
            :index="idx"
          />
        </ListResponsiveWrapper>
      </transition>
      <Loading class="absolute left-1/2 -translate-x-5 top-80" v-if="pending" />
    </div>
    <Pagination :current="current" :max="100" />
  </div>
</template>
